(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.headerObserver = null;
      this.mql = null;
      this.onMediaChange = null;
      this.onScrollHandler = null;
      this.hideHeaderOnScrollUp = null;
      this.headerBounds = { top: 0, bottom: 0 };
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.setHeaderHeight();

      this.mql = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      if (typeof this.mql.addEventListener === 'function') {
        this.mql.addEventListener('change', this.onMediaChange);
      } else if (typeof this.mql.addListener === 'function') {
        this.mql.addListener(this.onMediaChange);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      this.headerBounds.bottom = this.header.offsetHeight;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.mql && this.onMediaChange) {
        if (typeof this.mql.removeEventListener === 'function') {
          this.mql.removeEventListener('change', this.onMediaChange);
        } else if (typeof this.mql.removeListener === 'function') {
          this.mql.removeListener(this.onMediaChange);
        }
      }

      if (this.headerObserver) {
        this.headerObserver.disconnect();
      }
    }

    createObserver() {
      if (!this.header) return;

      if (!('IntersectionObserver' in window)) {
        const bounds = this.header.getBoundingClientRect();
        this.headerBounds = { top: bounds.top, bottom: bounds.bottom || this.header.offsetHeight };
        return;
      }

      this.headerObserver = new IntersectionObserver((entries, observer) => {
        const entry = entries && entries[0];
        if (!entry) return;
        this.headerBounds = entry.intersectionRect;
        observer.disconnect();
      });

      this.headerObserver.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const headerBottom = this.headerBounds.bottom || this.header.offsetHeight;
      const headerTop = typeof this.headerBounds.top === 'number' ? this.headerBounds.top : 0;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > headerBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= headerTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (disclosure && typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && typeof this.searchModal.close === 'function') this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  const normalizeText = (value) => {
    const baseValue = (value || '').toLowerCase().trim();
    if (typeof baseValue.normalize !== 'function') return baseValue;
    return baseValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  };

  const isCustomerServiceLink = (link) => {
    const label = normalizeText(link.textContent);
    const href = normalizeText(link.getAttribute('href'));

    return (
      label.includes('service client') ||
      label.includes('service-client') ||
      href.includes('service-client') ||
      href.includes('/pages/service-client')
    );
  };

  const removeCustomerServiceLinkFromHeader = (root = document) => {
    const headerRoot =
      root && typeof root.querySelector === 'function'
        ? root.querySelector('.section-header') || document.querySelector('.section-header')
        : document.querySelector('.section-header');
    if (!headerRoot) return;

    const links = headerRoot.querySelectorAll('a');
    links.forEach((link) => {
      if (!isCustomerServiceLink(link)) return;
      const container = link.closest('li') || link.closest('.menu-drawer__menu-item') || link;
      if (container) container.remove();
    });
  };

  const refinedHeaderCartIconSvg =
    "<span class='custom-icon' data-refined-icon='true' aria-hidden='true'><svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><path d='M6 7h12l-1 12H7L6 7z'/><path d='M9 7V5a3 3 0 0 1 6 0v2'/></svg></span>";
  const refinedHeaderAccountIconSvg =
    "<span class='custom-icon' data-refined-icon='true' aria-hidden='true'><svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'><circle cx='12' cy='8' r='4'/><path d='M4 20c0-4 4-6 8-6s8 2 8 6'/></svg></span>";

  const replaceHeaderIconMarkup = (link, refinedIconMarkup) => {
    if (!link) return;

    const childElements = Array.from(link.children).filter((child) => child instanceof Element);
    const hasLegacyIconNode = childElements.some((child) =>
      child.matches('.svg-wrapper, account-icon, shop-user-avatar')
    );
    const existingCustomIcon = childElements.find((child) => child.matches('.custom-icon'));
    const isAlreadyRefined =
      existingCustomIcon &&
      existingCustomIcon.getAttribute('data-refined-icon') === 'true' &&
      !hasLegacyIconNode;

    if (isAlreadyRefined) return;

    childElements.forEach((child) => {
      if (!(child instanceof Element)) return;
      if (child.matches('.custom-icon, .svg-wrapper, account-icon, shop-user-avatar')) {
        child.remove();
      }
    });

    link.insertAdjacentHTML('afterbegin', refinedIconMarkup);
  };

  const enforceRefinedHeaderIcons = (root = document) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const accountLinks = scope.querySelectorAll('.header__icon--account');
    const cartLinks = scope.querySelectorAll('#cart-icon-bubble, .header__icon--cart');

    accountLinks.forEach((link) => replaceHeaderIconMarkup(link, refinedHeaderAccountIconSvg));
    cartLinks.forEach((link) => replaceHeaderIconMarkup(link, refinedHeaderCartIconSvg));
  };

  const menuDrawerCartIconSvg =
    "<svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><path d='M6 7h12l-1 12H7L6 7z'/><path d='M9 7V5a3 3 0 0 1 6 0v2'/></svg>";
  const menuDrawerAccountIconSvg =
    "<svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><circle cx='12' cy='8' r='4'/><path d='M4 20c0-4 4-6 8-6s8 2 8 6'/></svg>";

  const isMenuDrawerCartLink = (link) => {
    const href = normalizeText(link.getAttribute('href'));
    const label = normalizeText(link.textContent);
    return href.includes('/cart') || label.includes('panier') || label === 'cart';
  };

  const isMenuDrawerAccountLink = (link) => {
    const href = normalizeText(link.getAttribute('href'));
    const label = normalizeText(link.textContent);
    return href.includes('/account') || label.includes('compte') || label.includes('account');
  };

  const addCustomIconToDrawerLink = (link, type) => {
    if (!link) return;
    if (link.dataset.customIconApplied === type) return;

    const labelText = (link.textContent || '').replace(/\s+/g, ' ').trim();
    if (!labelText) return;

    const iconWrapper = document.createElement('span');
    iconWrapper.className = `menu-drawer-custom-icon menu-drawer-custom-icon--${type}`;
    iconWrapper.setAttribute('aria-hidden', 'true');
    iconWrapper.innerHTML = type === 'cart' ? menuDrawerCartIconSvg : menuDrawerAccountIconSvg;

    const labelWrapper = document.createElement('span');
    labelWrapper.className = 'menu-drawer-custom-label';
    labelWrapper.textContent = labelText;

    while (link.firstChild) {
      link.removeChild(link.firstChild);
    }

    link.classList.add('menu-drawer-custom-link-icon');
    link.dataset.customIconApplied = type;
    link.append(iconWrapper, labelWrapper);
  };

  const isCartPath = (href) => {
    if (!href) return false;
    try {
      const url = new URL(href, window.location.origin);
      return /\/cart\/?$/.test(url.pathname);
    } catch (e) {
      return false;
    }
  };

  const triggerHeaderCartBehavior = () => {
    const headerCartTrigger = document.querySelector('#cart-icon-bubble');
    if (!headerCartTrigger) return false;

    const clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
    const dispatchSucceeded = headerCartTrigger.dispatchEvent(clickEvent);
    return !dispatchSucceeded || clickEvent.defaultPrevented;
  };

  const bindMobileExtraCartLinks = (root = document) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const cartLinks = scope.querySelectorAll('.mobile-extra a[href], .menu-drawer .mobile-extra a[href]');

    cartLinks.forEach((link) => {
      if (!isCartPath(link.getAttribute('href'))) return;
      if (link.dataset.cartDrawerBound === 'true') return;

      link.dataset.cartDrawerBound = 'true';
      link.addEventListener('click', (event) => {
        const opened = triggerHeaderCartBehavior();
        if (opened) {
          event.preventDefault();
          event.stopPropagation();
        }
      });
    });
  };

  const applyCustomIconsToMenuDrawer = (root = document) => {
    const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    const drawerLinks = Array.from(scope.querySelectorAll('.menu-drawer a[href]'));
    const cartLink = drawerLinks.find((link) => isMenuDrawerCartLink(link));
    const accountLink = drawerLinks.find((link) => isMenuDrawerAccountLink(link));

    if (cartLink) addCustomIconToDrawerLink(cartLink, 'cart');
    if (accountLink) addCustomIconToDrawerLink(accountLink, 'account');
  };

  const runHeaderEnhancements = (root = document) => {
    enforceRefinedHeaderIcons(root);
    removeCustomerServiceLinkFromHeader(root);
    applyCustomIconsToMenuDrawer(root);
    bindMobileExtraCartLinks(root);
  };

  const observeHeaderForCustomerServiceLink = () => {
    const state = window.__obaiaHeaderEnhancementState || {};
    const setState = (nextState) => {
      window.__obaiaHeaderEnhancementState = nextState;
      return nextState;
    };

    const headerRoot = document.querySelector('.section-header');
    if (!headerRoot) return;

    if (state.observer) {
      state.observer.disconnect();
    }

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        runHeaderEnhancements(document);
      });
    });

    observer.observe(headerRoot, { childList: true, subtree: true });
    setState({ ...state, observer });
  };

  const initializeHeaderEnhancements = () => {
    runHeaderEnhancements(document);
    observeHeaderForCustomerServiceLink();
  };

  const enhancementState = window.__obaiaHeaderEnhancementState || {};
  if (!enhancementState.listenersBound) {
    document.addEventListener('DOMContentLoaded', initializeHeaderEnhancements);
    document.addEventListener('shopify:section:load', initializeHeaderEnhancements);
    document.addEventListener('cart:refresh', initializeHeaderEnhancements);
    document.addEventListener('cart:updated', initializeHeaderEnhancements);
    document.addEventListener('cart-update', initializeHeaderEnhancements);
    window.__obaiaHeaderEnhancementState = { ...enhancementState, listenersBound: true };
  }

  initializeHeaderEnhancements();


  } catch(e) { console.error(e); }
})();
})();
